module.exports = __webpack_public_path__ + "img/logotipo.0a576038.svg";